import React, { FC } from 'react'
import Box, { BoxProps } from '@mui/material/Box'

const AdultPrimaryCareDoctor: FC<BoxProps<'svg'>> = (props) => (
  <Box
    component="svg"
    xmlns="http://www.w3.org/2000/svg"
    width={307}
    height={350}
    fill="none"
    viewBox="0 0 307 350"
    {...props}
  >
    <mask
      id="mask0_3690_7613"
      style={{ maskType: 'luminance' }}
      maskUnits="userSpaceOnUse"
      x="-43"
      y="0"
      width="350"
      height="350"
    >
      <path d="M307 0H-43V350H307V0Z" fill="white" />
    </mask>
    <g mask="url(#mask0_3690_7613)">
      <path
        d="M99.997 50.738L89.1006 67.3495V106.401C89.1006 106.401 99.4978 119.384 123.336 119.825L121.57 36.8323L99.997 50.738Z"
        fill="#733127"
      />
    </g>
    <mask
      id="mask1_3690_7613"
      style={{ maskType: 'luminance' }}
      maskUnits="userSpaceOnUse"
      x="-43"
      y="0"
      width="350"
      height="350"
    >
      <path d="M307 0H-43V350H307V0Z" fill="white" />
    </mask>
    <g mask="url(#mask1_3690_7613)">
      <path
        d="M153.112 50.738L164.008 67.3495V106.401C164.008 106.401 153.611 119.384 129.772 119.825L131.538 36.8323L153.112 50.738Z"
        fill="#733127"
      />
    </g>
    <mask
      id="mask2_3690_7613"
      style={{ maskType: 'luminance' }}
      maskUnits="userSpaceOnUse"
      x="-43"
      y="0"
      width="350"
      height="350"
    >
      <path d="M307 0H-43V350H307V0Z" fill="white" />
    </mask>
    <g mask="url(#mask2_3690_7613)">
      <path
        d="M76.0438 278.419C75.3515 278.366 74.6341 278.339 73.9847 278.585C73.2215 278.873 72.6421 279.505 72.1583 280.162C69.3425 283.986 68.9232 289.013 68.6529 293.754C67.4867 314.202 67.949 321.875 72.707 345.157C75.4504 358.582 82.1014 413.802 83.9971 413.802C91.6602 413.802 167.867 413.023 175.084 413.023C176.908 371.116 191.408 328.293 189.362 286.389C189.276 284.617 188.221 282.796 187.479 281.186C183.393 272.317 82.0732 278.883 76.0438 278.419Z"
        fill="#002677"
      />
      <mask
        id="mask3_3690_7613"
        style={{ maskType: 'luminance' }}
        maskUnits="userSpaceOnUse"
        x="68"
        y="276"
        width="122"
        height="138"
      >
        <path
          d="M76.0438 278.419C75.3515 278.366 74.6341 278.339 73.9847 278.585C73.2215 278.873 72.6421 279.505 72.1583 280.162C69.3425 283.986 68.9232 289.013 68.6529 293.754C67.4867 314.202 67.949 321.875 72.707 345.157C75.4504 358.582 82.1014 413.802 83.9971 413.802C91.6602 413.802 167.867 413.023 175.084 413.023C176.908 371.116 191.408 328.293 189.362 286.389C189.276 284.617 188.221 282.796 187.479 281.186C183.393 272.317 82.0732 278.883 76.0438 278.419Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask3_3690_7613)">
        <path
          d="M156.528 320.634C156.528 320.654 156.528 419.528 156.528 419.528C167.205 419.528 168.021 419.884 178.445 417.576C179.093 417.432 179.783 417.253 180.219 416.752C180.657 416.249 180.738 415.537 180.799 414.873C181.831 403.702 182.865 392.533 183.897 381.362C183.796 382.408 205.43 275.977 193.898 277.023C195.764 276.854 163.734 280.677 155.889 286.164C151.229 289.423 153.251 295.766 153.712 300.821C154.3 307.271 156.528 314.23 156.528 320.634Z"
          fill="#000C44"
        />
      </g>
    </g>
    <mask
      id="mask4_3690_7613"
      style={{ maskType: 'luminance' }}
      maskUnits="userSpaceOnUse"
      x="-43"
      y="0"
      width="350"
      height="350"
    >
      <path d="M307 0H-43V350H307V0Z" fill="white" />
    </mask>
    <g mask="url(#mask4_3690_7613)">
      <path
        d="M175.732 139.811C169.161 135.213 161.842 131.876 154.577 128.738C152.074 127.657 149.418 126.556 146.726 126.744C144.706 122.488 143.608 117.059 144.419 107.581H108.297C109.149 117.536 107.895 123.025 105.678 127.378C105.562 127.328 105.439 127.282 105.302 127.243C104.153 126.921 102.935 127.288 101.808 127.68C90.4798 131.628 80.308 138.702 72.1639 147.469C62.0998 158.303 55.4461 171.717 50.6233 185.582C45.3035 200.876 41.4933 216.973 38.4482 232.867C38.8257 230.898 48.8521 231.79 54.2987 233.06C67.3448 235.492 74.3516 240.431 74.3515 240.431C73.2655 247.969 73.1602 255.447 72.1409 262.497C70.9322 270.857 67.9527 279.318 67.5302 287.779C67.3253 291.882 67.1625 296.197 69.0054 299.869C71.4917 304.823 76.9633 307.393 82.0449 309.605C95.1612 315.317 105.528 318.601 120.191 323.921C123.101 318.645 125.77 315.126 129.534 308.956C132.846 313.294 135.503 317.78 140.4 324.22C147.52 320.627 158.166 315.618 165.421 312.307C180.186 305.569 188.368 299.047 189.15 297.232C190.246 294.691 190.386 291.743 190.254 289.019C190.034 284.493 189.029 280.128 188.214 275.692C187.365 271.068 186.595 266.415 186.344 261.715C186.218 259.359 186.121 256.785 186.876 254.513C188.578 249.394 193.814 245.208 197.926 242.074C204.554 237.023 212.064 232.789 219.712 229.471L227.43 223.103C209.232 199.851 201.881 158.108 175.732 139.811Z"
        fill="#F9D466"
      />
      <mask
        id="mask5_3690_7613"
        style={{ maskType: 'luminance' }}
        maskUnits="userSpaceOnUse"
        x="38"
        y="107"
        width="190"
        height="218"
      >
        <path
          d="M175.732 139.811C169.161 135.213 161.842 131.876 154.577 128.738C152.074 127.657 149.418 126.556 146.726 126.744C144.706 122.488 143.608 117.059 144.419 107.581H108.297C109.149 117.536 107.895 123.025 105.678 127.378C105.562 127.328 105.439 127.282 105.302 127.243C104.153 126.921 102.935 127.288 101.808 127.68C90.4798 131.628 80.308 138.702 72.1639 147.469C62.0998 158.303 55.4461 171.717 50.6233 185.582C45.3035 200.876 41.4933 216.973 38.4482 232.867C38.8257 230.898 48.8521 231.79 54.2987 233.06C67.3448 235.492 74.3516 240.431 74.3515 240.431C73.2655 247.969 73.1602 255.447 72.1409 262.497C70.9322 270.857 67.9527 279.318 67.5302 287.779C67.3253 291.882 67.1625 296.197 69.0054 299.869C71.4917 304.823 76.9633 307.393 82.0449 309.605C95.1612 315.317 105.528 318.601 120.191 323.921C123.101 318.645 125.77 315.126 129.534 308.956C132.846 313.294 135.503 317.78 140.4 324.22C147.52 320.627 158.166 315.618 165.421 312.307C180.186 305.569 188.368 299.047 189.15 297.232C190.246 294.691 190.386 291.743 190.254 289.019C190.034 284.493 189.029 280.128 188.214 275.692C187.365 271.068 186.595 266.415 186.344 261.715C186.218 259.359 186.121 256.785 186.876 254.513C188.578 249.394 193.814 245.208 197.926 242.074C204.554 237.023 212.064 232.789 219.712 229.471L227.43 223.103C209.232 199.851 201.881 158.108 175.732 139.811Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask5_3690_7613)">
        <path
          d="M176.004 267.835C174.168 267.37 169.893 268.031 168.021 267.738C159.995 266.481 151.814 266.833 143.697 267.188C135.274 267.557 126.85 267.926 118.433 268.437C103.118 269.365 87.8307 270.763 72.6007 272.628C72.2027 275.017 75.2559 276.338 77.6485 276.718C104.66 281.005 132.544 277.139 159.418 282.217C160.958 282.508 162.533 282.844 163.846 283.7C172.473 289.319 159.523 312.445 155.686 318.388C154.599 320.072 152.987 322.72 150.753 322.97C153.626 322.639 191.748 302.999 192.156 299.22C192.677 294.391 195.586 283.254 192.233 278.662C189.978 275.574 189.731 271.911 186.226 270.385C183.183 269.059 179.221 268.651 176.004 267.835Z"
          fill="#F5B700"
        />
      </g>
    </g>
    <mask
      id="mask6_3690_7613"
      style={{ maskType: 'luminance' }}
      maskUnits="userSpaceOnUse"
      x="-43"
      y="0"
      width="350"
      height="350"
    >
      <path d="M307 0H-43V350H307V0Z" fill="white" />
    </mask>
    <g mask="url(#mask6_3690_7613)">
      <path
        d="M98.6758 129.103C98.7333 128.586 98.8199 128.073 98.935 127.566C99.012 127.227 99.093 126.888 99.2039 126.558C99.2552 126.405 99.3288 126.256 99.3588 126.099C99.3898 125.937 99.4002 125.797 99.4846 125.645C99.5064 125.606 99.5313 125.568 99.5671 125.541C99.5996 125.517 99.6391 125.504 99.6778 125.492C101.496 124.914 103.563 124.73 105.462 124.803C105.359 124.799 104.809 125.573 104.704 125.68C104.464 125.925 104.257 126.068 103.959 126.217C103.212 126.591 102.554 127.197 101.847 127.649C100.895 128.257 99.8153 128.98 98.6758 129.103Z"
        fill="#F5B700"
      />
    </g>
    <mask
      id="mask7_3690_7613"
      style={{ maskType: 'luminance' }}
      maskUnits="userSpaceOnUse"
      x="-43"
      y="0"
      width="350"
      height="350"
    >
      <path d="M307 0H-43V350H307V0Z" fill="white" />
    </mask>
    <g mask="url(#mask7_3690_7613)">
      <path
        d="M38.4481 232.868C38.867 230.676 51.231 232.027 55.944 233.499C60.6569 234.972 73.2033 244.477 65.9229 244.477C58.6424 244.477 37.3513 238.604 38.4481 232.868Z"
        fill="#F5B700"
      />
    </g>
    <mask
      id="mask8_3690_7613"
      style={{ maskType: 'luminance' }}
      maskUnits="userSpaceOnUse"
      x="-43"
      y="0"
      width="350"
      height="350"
    >
      <path d="M307 0H-43V350H307V0Z" fill="white" />
    </mask>
    <g mask="url(#mask8_3690_7613)">
      <path
        d="M72.7155 259.141C70.9121 266.322 66.1033 270.965 51.9688 269.225C38.1761 267.527 42.9615 231.778 42.9698 231.716C46.4345 231.713 51.1379 232.323 54.2988 233.06C67.345 235.492 74.3517 240.431 74.3517 240.431C73.7331 247.016 74.061 253.784 72.7155 259.141Z"
        fill="#E79B52"
      />
    </g>
    <mask
      id="mask9_3690_7613"
      style={{ maskType: 'luminance' }}
      maskUnits="userSpaceOnUse"
      x="-43"
      y="0"
      width="350"
      height="350"
    >
      <path d="M307 0H-43V350H307V0Z" fill="white" />
    </mask>
    <g mask="url(#mask9_3690_7613)">
      <path
        d="M144.418 107.581C144.418 107.581 108.296 107.581 108.296 107.581C108.848 114.027 109.055 120.266 104.367 125.143C103.017 126.547 100.77 127.698 99.8645 129.463C98.5547 132.016 100.406 133.84 101.826 136.08C107.918 145.688 115.741 153.73 121.157 163.809C122.884 167.021 124.378 170.344 125.849 173.679C126.991 176.269 127.455 177.434 130.221 176.132C138.363 172.301 142.941 158.93 146.151 151.326C148.974 144.638 151.532 137.796 153.689 130.862C148.213 122.39 142.879 125.571 144.418 107.581Z"
        fill="#E79B52"
      />
      <mask
        id="mask10_3690_7613"
        style={{ maskType: 'luminance' }}
        maskUnits="userSpaceOnUse"
        x="99"
        y="107"
        width="55"
        height="70"
      >
        <path
          d="M144.418 107.581C144.418 107.581 108.296 107.581 108.296 107.581C108.848 114.027 109.055 120.266 104.367 125.143C103.017 126.547 100.77 127.698 99.8645 129.463C98.5547 132.016 100.406 133.84 101.826 136.08C107.918 145.688 115.741 153.73 121.157 163.809C122.884 167.021 124.378 170.344 125.849 173.679C126.991 176.269 127.455 177.434 130.221 176.132C138.363 172.301 142.941 158.93 146.151 151.326C148.974 144.638 151.532 137.796 153.689 130.862C148.213 122.39 142.879 125.571 144.418 107.581Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask10_3690_7613)">
        <path
          d="M105.811 111.068C106.026 111.029 106.255 111.024 106.471 111.024C107.258 111.023 107.788 111.485 108.482 111.82C109.266 112.197 110.065 112.542 110.875 112.857C112.461 113.473 114.093 113.969 115.751 114.35C119.072 115.112 122.496 115.411 125.9 115.281C129.4 115.146 132.861 114.508 136.228 113.556C137.904 113.082 139.558 112.532 141.195 111.935C142.696 111.388 144.323 110.339 145.948 110.9C146.201 110.987 146.446 111.106 146.648 111.28C147.041 111.62 147.237 112.146 147.265 112.663C147.292 113.181 147.167 112.017 147.003 112.509C145.51 116.998 142.175 121.769 138.51 124.542C135.618 126.73 131.687 128.553 128.013 128.999C123.894 129.498 120.385 128.144 116.906 126.079C112.624 123.539 108.116 118.305 105.609 113.924C105.408 113.573 105.206 114.899 105.078 114.517C104.881 113.932 104.864 113.305 104.848 112.689C104.836 112.227 104.844 111.712 105.165 111.38C105.338 111.202 105.565 111.113 105.811 111.068Z"
          fill="#D28960"
        />
      </g>
    </g>
    <mask
      id="mask11_3690_7613"
      style={{ maskType: 'luminance' }}
      maskUnits="userSpaceOnUse"
      x="-43"
      y="0"
      width="350"
      height="350"
    >
      <path d="M307 0H-43V350H307V0Z" fill="white" />
    </mask>
    <g mask="url(#mask11_3690_7613)">
      <path
        d="M192.156 243.982C188.741 239.13 187.122 235.769 187.122 235.769C186.383 235.662 185.326 233.838 184.856 235.011C184.386 236.183 179.322 235.466 179.322 235.466C177.268 231.628 165.799 236.603 165.799 236.603L163.201 239.277C156.351 237.493 151.474 242.356 150.879 244.223C150.317 245.984 151.645 247.176 155.008 247.455C158.736 247.765 165.481 248.618 171.165 252.477L171.161 252.469C179.868 259.035 188.301 260.63 191.446 258.209C191.679 258.029 191.919 257.784 192.156 257.491V243.982Z"
        fill="#E79B52"
      />
      <path
        d="M217.65 220.943C217.65 220.943 223.989 241.238 219.854 254.136C215.371 268.118 198.642 266.389 185.39 259.857C185.39 259.857 188.032 238.535 188.747 238.201C189.462 237.867 200.98 220.191 217.65 220.943Z"
        fill="#E79B52"
      />
      <path
        d="M166.59 233.034C165.148 232.339 159.987 232.903 158.429 233.21C155.084 233.87 149.567 235.064 149.567 235.064C145.672 235.786 146.682 237.935 147.475 238.486C149.563 239.938 153.77 239.871 157.811 239.535C159.836 239.367 160.963 239.973 160.963 239.973C164.145 239.161 168.118 236.658 168.118 236.658L166.59 233.034Z"
        fill="#E79B52"
      />
      <path
        d="M164.297 231.481C162.714 231.552 161.191 232.134 159.933 233.154C157.231 235.343 152.819 239.048 152.819 239.048C151.602 240.022 150.147 240.873 151.384 242.52C153.068 244.145 159.91 240.33 164.317 237.487C166.052 236.369 171.652 231.481 171.652 231.481H164.297Z"
        fill="#D28960"
      />
      <path
        d="M174.967 229.957C173.739 229.954 172.897 230.517 172.046 231.11C169.203 233.091 163.922 236.506 163.922 236.506C162.643 237.385 161.337 237.768 161.853 239.356C162.526 241.173 167.814 240.741 172.07 237.651C175.936 234.844 177.364 235.7 177.364 235.7L180.664 231.225C180.664 231.225 176.061 229.96 174.967 229.957Z"
        fill="#D28960"
      />
      <path
        d="M186.903 240.333C187.418 243.19 186.957 249.993 189.144 253.815L195.657 254.564C195.586 250.255 194.277 247.032 192.855 244.961C189.095 239.483 187.171 232.701 183.222 230.55L183.222 230.554C182.681 230.256 181.991 230.042 181.092 229.989C179.952 229.911 178.856 230.053 178.331 230.889C176.922 233.133 174.696 237.204 173.876 238.718C173.685 239.069 173.484 239.412 173.28 239.755C172.645 240.822 172.222 242.009 173.164 242.819C174.306 243.681 176.672 242.529 178.873 239.939C180.913 237.537 182.639 235.82 182.882 235.798C184.47 235.654 186.204 236.455 186.903 240.333Z"
        fill="#D28960"
      />
    </g>
    <mask
      id="mask12_3690_7613"
      style={{ maskType: 'luminance' }}
      maskUnits="userSpaceOnUse"
      x="-43"
      y="0"
      width="350"
      height="350"
    >
      <path d="M307 0H-43V350H307V0Z" fill="white" />
    </mask>
    <g mask="url(#mask12_3690_7613)">
      <path
        d="M201.639 256.656C201.31 256.174 200.777 255.84 200.117 255.84H167.954H84.1582H51.9951C51.3368 255.84 50.8053 256.172 50.4755 256.652C50.093 257.208 50.1804 257.986 50.6205 258.493L62.8725 272.591L188.362 272.593C188.885 272.593 189.384 272.362 189.739 271.955L201.496 258.493C201.934 257.987 202.02 257.213 201.639 256.656Z"
        fill="#D2C8BE"
      />
      <path
        d="M200.609 251.878H51.5037C49.896 251.878 48.5928 253.258 48.5928 254.96C48.5928 255.726 48.8583 256.426 49.2963 256.964C49.3238 256.998 49.8261 257.577 50.6213 258.493C50.1804 257.985 50.0932 257.207 50.4775 256.649C50.8074 256.171 51.3382 255.84 51.9953 255.84H84.1584H167.954H200.117C200.776 255.84 201.308 256.172 201.638 256.653C202.02 257.211 201.934 257.987 201.495 258.495C202.277 257.591 202.765 257.026 202.782 257.007C203.24 256.463 203.52 255.746 203.52 254.96C203.52 253.258 202.216 251.878 200.609 251.878Z"
        fill="#EBE6E1"
      />
      <path
        d="M178.491 255.186H185.455C186.211 255.186 186.824 254.573 186.824 253.817C186.824 253.06 186.211 252.447 185.455 252.447H178.491C177.734 252.447 177.121 253.06 177.121 253.817C177.121 254.573 177.734 255.186 178.491 255.186Z"
        fill="#D2C8BE"
      />
    </g>
    <mask
      id="mask13_3690_7613"
      style={{ maskType: 'luminance' }}
      maskUnits="userSpaceOnUse"
      x="-43"
      y="0"
      width="350"
      height="350"
    >
      <path d="M307 0H-43V350H307V0Z" fill="white" />
    </mask>
    <g mask="url(#mask13_3690_7613)">
      <path
        d="M82.2976 263.023C82.1562 262.067 81.2549 261.304 79.8915 260.999C79.8893 260.943 79.8884 260.886 79.8829 260.828C79.7575 259.488 78.1451 258.425 75.7956 258.425C73.0899 258.348 65.9789 259.029 65.9789 259.029C65.9789 259.029 47.9743 260.368 43.2399 255.623C43.2399 255.623 41.4806 257.658 40.7794 259.464C39.632 262.42 40.6098 263.289 41.272 264.738C41.4305 265.085 41.3974 265.502 41.3486 265.872C41.2826 266.372 41.1643 266.863 41.0772 267.359C40.8845 268.457 40.8365 269.635 41.4828 270.585C41.8081 271.064 42.2572 271.452 42.7556 271.714C43.3559 272.03 43.7922 272.017 44.1866 272.36C45.1689 273.214 44.6551 274.677 45.9566 275.746C46.4602 276.136 47.1554 276.319 47.4534 276.386C48.3942 276.548 49.5493 276.511 50.4365 276.427C50.4365 276.427 50.5228 276.514 50.4365 276.427C53.133 279.159 57.1727 278.011 60.1189 276.469C63.4147 274.744 66.4181 272.434 69.4702 270.283C70.7089 269.409 71.9626 268.509 73.2721 267.732C74.9764 267.155 77.1012 266.306 78.9926 265.74C81.6852 264.899 82.516 264.498 82.2976 263.023Z"
        fill="#D28960"
      />
    </g>
    <mask
      id="mask14_3690_7613"
      style={{ maskType: 'luminance' }}
      maskUnits="userSpaceOnUse"
      x="-43"
      y="0"
      width="350"
      height="350"
    >
      <path d="M307 0H-43V350H307V0Z" fill="white" />
    </mask>
    <g mask="url(#mask14_3690_7613)">
      <path
        d="M41.4285 269.543C41.8237 269.964 42.3302 270.246 42.886 270.326C44.1351 270.505 46.3091 270.279 48.5445 269.545C49.4386 269.23 50.1607 268.901 50.6894 268.631L50.7096 268.621C51.0857 268.429 51.0324 267.845 50.6285 267.732L41.415 265.286C41.2804 266.315 40.7667 267.507 41.0152 268.75C41.0742 269.045 41.2186 269.318 41.4186 269.532C41.4219 269.536 41.4252 269.539 41.4285 269.543Z"
        fill="#E79B52"
      />
    </g>
    <mask
      id="mask15_3690_7613"
      style={{ maskType: 'luminance' }}
      maskUnits="userSpaceOnUse"
      x="-43"
      y="0"
      width="350"
      height="350"
    >
      <path d="M307 0H-43V350H307V0Z" fill="white" />
    </mask>
    <g mask="url(#mask15_3690_7613)">
      <path
        d="M47.9742 255.7C47.9742 255.7 48.9188 257.203 54.7652 257.442C60.2603 257.668 63.0614 257.083 66.7351 256.631C68.879 256.367 73.5072 256.491 72.4049 259.602C71.8372 261.205 63.7621 261.989 57.7068 263.375C53.7571 264.278 51.6689 262.841 42.9029 261.285C40.9418 260.937 40.5157 259.905 40.3059 258.955C40.1691 258.335 40.0274 256.38 41.4801 255.186C42.0951 254.681 43.1264 253.862 44.3295 254.297L47.9742 255.7Z"
        fill="#E79B52"
      />
    </g>
    <mask
      id="mask16_3690_7613"
      style={{ maskType: 'luminance' }}
      maskUnits="userSpaceOnUse"
      x="-43"
      y="0"
      width="350"
      height="350"
    >
      <path d="M307 0H-43V350H307V0Z" fill="white" />
    </mask>
    <g mask="url(#mask16_3690_7613)">
      <path
        d="M227.429 223.103C227.429 223.103 221.28 220.846 217.65 220.943C217.65 220.943 218.743 224.444 219.725 229.459L227.429 223.103Z"
        fill="#F5B700"
      />
    </g>
    <mask
      id="mask17_3690_7613"
      style={{ maskType: 'luminance' }}
      maskUnits="userSpaceOnUse"
      x="-43"
      y="0"
      width="350"
      height="350"
    >
      <path d="M307 0H-43V350H307V0Z" fill="white" />
    </mask>
    <g mask="url(#mask17_3690_7613)">
      <path
        d="M109.344 158.244C110.192 158.182 111.003 158.373 111.827 159.141C112.456 159.727 112.7 160.54 113.131 161.257C113.581 162.007 114.097 162.767 114.667 163.438C115.856 164.836 117.328 165.96 118.783 167.064C119.689 167.752 120.594 168.44 121.5 169.128C122.79 170.107 124.131 171.111 125.708 171.478C125.396 169.598 123.91 168.155 122.736 166.755C121.381 165.138 120.105 163.454 118.958 161.683C117.178 158.936 116.011 154.288 113.079 152.533C110.522 151.001 109.158 153.485 107.501 155.599C106.464 156.921 105.107 158.147 103.79 159.227C104.317 159.21 104.781 159.12 105.307 159.103C106.823 158.944 108.121 158.332 109.344 158.244Z"
        fill="#F5B700"
      />
    </g>
    <mask
      id="mask18_3690_7613"
      style={{ maskType: 'luminance' }}
      maskUnits="userSpaceOnUse"
      x="-43"
      y="0"
      width="350"
      height="350"
    >
      <path d="M307 0H-43V350H307V0Z" fill="white" />
    </mask>
    <g mask="url(#mask18_3690_7613)">
      <path
        d="M148.093 154.217C149.694 151.489 152.36 146.183 154.902 152.477C155.111 152.994 155.247 153.537 155.364 154.083C155.738 155.84 156.377 157.54 157.25 159.11C155.854 159.333 154.403 159.489 153.044 159.098C151.685 158.707 150.432 157.647 150.211 156.251C149.297 157.201 146.614 159.408 144.786 160.905C144.498 161.141 144.103 160.79 144.302 160.475C145.557 158.49 147.324 155.527 148.093 154.217Z"
        fill="#F5B700"
      />
    </g>
    <mask
      id="mask19_3690_7613"
      style={{ maskType: 'luminance' }}
      maskUnits="userSpaceOnUse"
      x="-43"
      y="0"
      width="350"
      height="350"
    >
      <path d="M307 0H-43V350H307V0Z" fill="white" />
    </mask>
    <g mask="url(#mask19_3690_7613)">
      <path
        d="M126.554 105.557C147.239 105.557 164.008 88.6175 164.008 67.7213C164.008 46.8252 147.239 29.8855 126.554 29.8855C105.869 29.8855 89.1006 46.8252 89.1006 67.7213C89.1006 88.6175 105.869 105.557 126.554 105.557Z"
        fill="#733127"
      />
    </g>
    <mask
      id="mask20_3690_7613"
      style={{ maskType: 'luminance' }}
      maskUnits="userSpaceOnUse"
      x="-43"
      y="0"
      width="350"
      height="350"
    >
      <path d="M307 0H-43V350H307V0Z" fill="white" />
    </mask>
    <g mask="url(#mask20_3690_7613)">
      <path
        d="M154.851 99.8046C154.306 100.047 153.728 100.225 153.12 100.324C153.772 98.2198 155.521 85.1589 155.521 85.1589C155.898 80.611 158.937 79.3958 160.7 81.0145C162.416 82.591 161.999 86.7016 161.448 89.3296C160.888 92.0003 159.985 94.7075 158.332 96.9194C157.411 98.1514 156.238 99.1874 154.851 99.8046Z"
        fill="#E79B52"
      />
    </g>
    <mask
      id="mask21_3690_7613"
      style={{ maskType: 'luminance' }}
      maskUnits="userSpaceOnUse"
      x="-43"
      y="0"
      width="350"
      height="350"
    >
      <path d="M307 0H-43V350H307V0Z" fill="white" />
    </mask>
    <g mask="url(#mask21_3690_7613)">
      <path
        d="M97.6995 87.1362C97.7048 87.1245 97.7092 87.113 97.7145 87.1014C97.6666 87.0875 97.6995 87.1362 97.6995 87.1362Z"
        fill="#733127"
      />
    </g>
    <mask
      id="mask22_3690_7613"
      style={{ maskType: 'luminance' }}
      maskUnits="userSpaceOnUse"
      x="-43"
      y="0"
      width="350"
      height="350"
    >
      <path d="M307 0H-43V350H307V0Z" fill="white" />
    </mask>
    <g mask="url(#mask22_3690_7613)">
      <path
        d="M98.2658 99.8046C98.8105 100.047 99.3881 100.225 99.9964 100.324C99.3449 98.2198 97.5956 85.1589 97.5956 85.1589C97.2181 80.611 94.1795 79.3958 92.4168 81.0145C90.7001 82.591 91.1172 86.7016 91.6684 89.3296C92.2285 92.0003 93.1319 94.7075 94.7846 96.9194C95.705 98.1514 96.8784 99.1874 98.2658 99.8046Z"
        fill="#E79B52"
      />
    </g>
    <mask
      id="mask23_3690_7613"
      style={{ maskType: 'luminance' }}
      maskUnits="userSpaceOnUse"
      x="-43"
      y="0"
      width="350"
      height="350"
    >
      <path d="M307 0H-43V350H307V0Z" fill="white" />
    </mask>
    <g mask="url(#mask23_3690_7613)">
      <path
        d="M155.39 87.1013C155.34 86.9924 155.297 86.8839 155.25 86.7753C155.037 86.2825 154.272 68.7994 154.15 66.6983C154.15 66.6978 154.15 66.6971 154.15 66.6964C154.145 66.6069 154.136 66.5177 154.13 66.4283C154.13 66.4279 154.13 66.4275 154.13 66.4271C154.104 66.0647 154.071 65.7032 154.025 65.3437C154.025 65.3435 154.025 65.3433 154.025 65.343C154.02 65.3068 154.013 65.2709 154.009 65.2347C154.009 65.2343 154.008 65.234 154.008 65.2336C153.954 64.8316 153.888 64.4309 153.803 64.0323C153.76 63.8342 153.713 63.6326 153.663 63.4289C153.663 63.4281 153.663 63.4275 153.663 63.4267C153.662 63.4251 153.662 63.4234 153.661 63.4218C153.587 63.1228 153.503 62.8174 153.411 62.508C153.401 62.4751 153.392 62.4426 153.382 62.4095C153.29 62.1083 153.189 61.8028 153.08 61.4937C153.063 61.4469 153.046 61.4003 153.029 61.3535C152.916 61.0392 152.794 60.7222 152.661 60.4019C152.653 60.3826 152.644 60.3633 152.636 60.3441C152.502 60.0253 152.358 59.7041 152.204 59.3811C152.191 59.3543 152.179 59.3277 152.166 59.3007C152.011 58.978 151.843 58.6536 151.666 58.3285C151.639 58.28 151.613 58.2316 151.586 58.183C151.405 57.8571 151.215 57.5309 151.013 57.2047C150.995 57.1767 150.977 57.1487 150.959 57.1207C150.751 56.79 150.533 56.4598 150.301 56.1308C150.292 56.1181 150.284 56.1054 150.275 56.0927C150.043 55.7646 149.796 55.4383 149.539 55.1136C149.504 55.0685 149.468 55.0234 149.432 54.9783C149.174 54.658 148.905 54.34 148.623 54.0251C148.594 53.9931 148.564 53.9614 148.535 53.9294C147.947 53.282 147.303 52.649 146.602 52.0368C146.558 51.9988 146.516 51.9608 146.472 51.9234C146.128 51.6272 145.77 51.3364 145.397 51.0516C145.354 51.0183 145.309 50.9857 145.265 50.9527C144.492 50.3697 143.658 49.8133 142.759 49.2897C142.709 49.2601 142.659 49.2301 142.608 49.2008C142.168 48.9486 141.713 48.7051 141.242 48.4695C141.18 48.4383 141.117 48.408 141.054 48.3771C139.346 47.5395 137.44 46.815 135.303 46.2492C132.439 45.4908 129.496 45.1118 126.552 45.1121C123.609 45.1118 120.665 45.4908 117.801 46.2492C105.384 49.5364 100.567 58.0959 99.302 64.0323C97.8824 70.6936 97.7329 87.1079 97.746 87.1143C97.2169 89.4431 98.0472 91.8044 98.3128 94.3277C98.5151 96.2479 98.734 98.1671 98.9879 100.081C100.096 106.988 105.049 111.269 107.968 113.716C113.11 118.029 120.121 122.785 126.081 122.907C126.081 122.907 126.378 122.913 126.578 122.913C126.81 122.913 127.027 122.907 127.027 122.907C127.723 122.893 128.433 122.809 129.152 122.678C129.167 122.675 129.182 122.672 129.197 122.669C129.539 122.606 129.882 122.53 130.228 122.443C130.23 122.442 130.233 122.442 130.235 122.441C130.473 122.381 130.712 122.315 130.951 122.245C130.952 122.244 130.953 122.244 130.954 122.244C130.968 122.24 130.982 122.235 130.996 122.231C131.952 121.945 132.917 121.579 133.881 121.147C133.882 121.147 133.882 121.147 133.883 121.146C133.885 121.145 133.887 121.144 133.89 121.143C133.891 121.143 133.892 121.143 133.893 121.142C134.195 121.007 134.496 120.865 134.797 120.718C134.798 120.718 134.799 120.717 134.8 120.717C135.708 120.273 136.611 119.778 137.503 119.245C137.504 119.244 137.504 119.244 137.505 119.244C137.505 119.243 137.506 119.243 137.507 119.243C137.507 119.242 137.508 119.242 137.509 119.241C138.835 118.449 140.135 117.577 141.38 116.669C141.399 116.656 141.416 116.639 141.434 116.625C141.435 116.625 141.436 116.625 141.436 116.624C144.418 114.446 147.087 112.082 149.059 110.208C150.117 109.202 153.159 106.308 154.033 100.106C154.086 99.7242 154.14 99.3431 154.191 98.9614C154.466 96.9183 154.713 94.871 154.928 92.8205C155.063 91.5278 155.185 90.2337 155.284 88.9378C155.329 88.35 155.444 87.7093 155.336 87.1264C155.36 87.113 155.378 87.1049 155.39 87.1013Z"
        fill="#E79B52"
      />
    </g>
    <mask
      id="mask24_3690_7613"
      style={{ maskType: 'luminance' }}
      maskUnits="userSpaceOnUse"
      x="-43"
      y="0"
      width="350"
      height="350"
    >
      <path d="M307 0H-43V350H307V0Z" fill="white" />
    </mask>
    <g mask="url(#mask24_3690_7613)">
      <path
        d="M177.341 183.719C177.63 179.179 174.387 175.276 170.098 175.003C165.809 174.73 162.097 178.189 161.808 182.73C161.519 187.27 164.761 191.173 169.051 191.446C173.34 191.719 177.052 188.26 177.341 183.719Z"
        fill="#EBE6E1"
      />
      <path
        d="M172.431 164.365C172.145 164.348 171.871 164.449 171.657 164.65C171.441 164.853 171.313 165.132 171.295 165.437C171.024 170.14 169.216 179.085 169.198 179.174C169.138 179.471 169.19 179.774 169.346 180.027C169.501 180.28 169.741 180.454 170.021 180.516C170.113 180.535 170.204 180.543 170.294 180.538C170.311 180.537 170.329 180.536 170.346 180.534C170.809 180.485 171.195 180.122 171.294 179.635C171.37 179.263 173.152 170.459 173.435 165.559C173.471 164.934 173.02 164.399 172.431 164.365Z"
        fill="#D2C8BE"
      />
      <path
        d="M174.063 183.51C174.23 180.886 172.356 178.631 169.877 178.473C167.398 178.315 165.253 180.314 165.086 182.939C164.919 185.563 166.793 187.818 169.272 187.976C171.751 188.134 173.896 186.135 174.063 183.51Z"
        fill="#D2C8BE"
      />
      <path
        d="M171.215 142.696C167.436 134.187 160.939 128.453 151.905 125.652L151.856 125.637C151.652 125.574 151.488 125.523 151.37 125.482C151.06 125.372 150.723 125.348 150.409 125.45C149.924 125.607 149.555 125.983 149.391 126.475C149.255 126.884 149.277 127.324 149.453 127.712C149.63 128.101 149.939 128.393 150.324 128.534C150.485 128.593 150.722 128.668 151.024 128.761C159.188 131.292 165.049 136.449 168.443 144.091C171.205 150.309 171.921 158.145 170.63 168.035C170.597 168.287 170.76 168.521 170.998 168.555L173.163 168.868C173.403 168.903 173.628 168.721 173.661 168.467C175.037 157.931 174.236 149.497 171.215 142.696Z"
        fill="#FF612B"
      />
    </g>
    <mask
      id="mask25_3690_7613"
      style={{ maskType: 'luminance' }}
      maskUnits="userSpaceOnUse"
      x="-43"
      y="0"
      width="350"
      height="350"
    >
      <path d="M307 0H-43V350H307V0Z" fill="white" />
    </mask>
    <g mask="url(#mask25_3690_7613)">
      <path
        d="M70.5496 167.845C71.1088 167.802 71.5478 167.58 71.53 167.349C71.5123 167.119 71.0445 166.967 70.4853 167.01C69.926 167.053 69.4871 167.275 69.5048 167.505C69.5226 167.736 69.9903 167.888 70.5496 167.845Z"
        fill="#D2C8BE"
      />
      <path
        d="M85.792 223.984C82.0304 223.743 78.6751 222.129 76.1727 219.557C72.909 222.148 68.6703 223.31 64.2341 222.489L61.7568 222.031L62.1149 219.947L64.5922 220.405C68.4491 221.119 72.0683 220.186 74.8668 218.024C73.0628 215.6 71.9073 212.568 71.6568 209.166L69.016 167.347C68.9809 166.79 68.9804 166.307 69.0142 165.781C69.4103 159.613 74.4729 154.9 80.2994 155.274C86.126 155.648 90.544 160.971 90.1479 167.139C90.1151 167.649 90.0461 168.115 89.9525 168.656L81.9854 209.817C81.3006 213.165 79.7652 216.028 77.6645 218.203C80.1637 220.705 83.6348 222.094 87.5519 221.879L90.0676 221.742L90.1561 223.855L87.6404 223.992C87.0152 224.026 86.3978 224.023 85.792 223.984ZM80.1638 157.386C75.4373 157.083 71.3308 160.906 71.0095 165.909C70.9816 166.343 70.9822 166.726 71.0115 167.191L73.6515 208.998C73.87 211.964 74.8372 214.583 76.3584 216.673C78.1359 214.792 79.4313 212.316 80.0285 209.396L87.9894 168.268C88.0689 167.806 88.1262 167.423 88.1527 167.01C88.474 162.007 84.8902 157.69 80.1638 157.386Z"
        fill="#D2C8BE"
      />
      <path
        d="M84.375 155.724C82.9724 155.029 82.1766 153.444 82.482 151.831C83.4126 146.916 85.0056 143.066 87.3824 139.931C88.7909 138.073 90.5775 136.526 92.4929 135.211C93.4842 134.53 94.5163 133.909 95.5739 133.337C96.4595 132.858 97.3077 132.539 97.6085 131.459C97.7909 130.804 97.6675 130.065 97.2587 129.522C97.1253 129.345 96.9613 129.187 96.7651 129.083C95.6981 128.521 94.4877 129.614 93.6224 130.155C92.5129 130.849 91.4381 131.6 90.404 132.402C88.3682 133.981 86.4524 135.766 84.8921 137.824C82.1518 141.439 80.3387 145.812 79.3104 151.359C78.9739 153.174 77.7247 154.653 76.0678 155.248C71.8821 156.75 68.7331 160.804 68.416 165.743C68.3803 166.298 68.3809 166.808 68.4177 167.394L69.0819 177.912C69.105 178.278 69.4039 178.552 69.7494 178.525L71.6907 178.373C72.0363 178.346 72.2977 178.028 72.2746 177.662L71.6104 167.145C71.584 166.723 71.5825 166.374 71.606 165.986C71.8382 162.145 74.4378 158.896 78.0139 158.169C83.4001 157.074 87.8996 161.597 87.5544 166.972C87.5298 167.355 87.4754 167.718 87.402 168.145L85.3966 178.505C85.327 178.865 85.5456 179.214 85.8848 179.285L87.7907 179.683C88.13 179.754 88.4614 179.521 88.531 179.161L90.5431 168.766C90.6402 168.203 90.7121 167.718 90.7468 167.177C91.0674 162.186 88.4047 157.72 84.375 155.724Z"
        fill="#FF612B"
      />
      <path
        d="M94.7257 222.882L94.6969 222.213C94.6527 221.19 93.8815 220.343 92.9133 220.332C92.8665 220.332 92.8194 220.333 92.772 220.336C92.3722 220.358 92.0023 220.492 91.6882 220.708C91.0529 221.146 90.3059 221.363 89.5514 221.406L89.2691 221.421C88.9199 221.441 88.5997 221.596 88.3594 221.837L88.4148 223.95C88.6662 224.174 88.9906 224.3 89.346 224.281L89.7705 224.257C90.5186 224.215 91.2524 224.405 91.9255 224.747C92.1962 224.885 92.4964 224.964 92.8109 224.97C92.9046 224.972 92.9969 224.968 93.0874 224.958C94.061 224.849 94.7703 223.916 94.7257 222.882Z"
        fill="#EB4600"
      />
      <path
        d="M55.7425 219.617L55.6403 220.279C55.484 221.291 56.0725 222.289 57.0164 222.511C57.062 222.522 57.1082 222.531 57.155 222.539C57.55 222.604 57.9376 222.553 58.2866 222.41C58.9924 222.12 59.7647 222.07 60.5101 222.193L60.789 222.239C61.134 222.296 61.4771 222.213 61.7587 222.031L62.1164 219.947C61.9144 219.673 61.6221 219.478 61.271 219.42L60.8516 219.351C60.1126 219.229 59.4326 218.882 58.8417 218.4C58.604 218.206 58.3262 218.063 58.0201 217.988C57.9289 217.966 57.8379 217.95 57.7475 217.94C56.7752 217.834 55.9003 218.594 55.7425 219.617Z"
        fill="#EB4600"
      />
    </g>
    <mask
      id="mask26_3690_7613"
      style={{ maskType: 'luminance' }}
      maskUnits="userSpaceOnUse"
      x="-43"
      y="0"
      width="350"
      height="350"
    >
      <path d="M307 0H-43V350H307V0Z" fill="white" />
    </mask>
    <g mask="url(#mask26_3690_7613)">
      <path
        d="M99.8321 125.388C100.064 125.323 100.211 125.322 100.545 125.26C100.339 125.634 100.37 126.185 100.399 126.598C100.432 127.067 100.534 127.529 100.673 127.978C100.954 128.883 101.385 129.732 101.804 130.58C103.159 133.32 105.525 135.755 107.45 138.142C111.505 143.174 115.948 147.881 120.025 152.883C121.763 155.015 131.151 174.388 130.16 177.281C129.341 177.698 128.306 177.416 127.593 176.837C126.879 176.258 126.418 175.433 125.974 174.628C123.068 169.367 119.836 164.295 116.919 159.04C116.386 157.974 116.008 157.132 115.257 156.177C114.631 155.382 113.768 153.967 112.814 153.549C111.82 153.114 109.912 153.55 109.042 154.102C108.011 154.757 107.421 155.945 106.422 156.649C106.076 156.893 105.635 157.078 105.235 156.938C105.058 156.877 104.907 156.757 104.764 156.635C102.403 154.633 101.235 151.683 99.7341 149.006C98.135 146.153 96.5519 143.278 95.3181 140.244C94.4386 138.082 91.8193 132.971 92.3809 130.602C92.6231 129.577 94.0906 128.677 94.8632 128.078C96.1156 127.107 97.5178 126.422 98.948 125.731C99.233 125.594 99.528 125.473 99.8321 125.388Z"
        fill="#F9D466"
      />
    </g>
    <mask
      id="mask27_3690_7613"
      style={{ maskType: 'luminance' }}
      maskUnits="userSpaceOnUse"
      x="-43"
      y="0"
      width="350"
      height="350"
    >
      <path d="M307 0H-43V350H307V0Z" fill="white" />
    </mask>
    <g mask="url(#mask27_3690_7613)">
      <path
        d="M150.431 124.078C149.535 123.657 147.98 123.192 146.874 123.367C149.879 128.702 150.425 134.976 147.941 140.453C145.565 145.69 143.133 150.902 140.646 156.087C138.458 160.649 130.951 171.953 130.231 173.197C129.51 174.442 129.114 175.955 129.531 177.331C129.567 177.448 129.614 177.571 129.714 177.641C129.852 177.738 130.039 177.701 130.201 177.655C132.968 176.863 134.936 174.455 136.548 172.071C139.974 167.001 143.909 162.277 147.522 157.333C153.117 149.68 158.756 140.277 155.709 130.503C154.914 127.954 153.016 125.291 150.431 124.078Z"
        fill="#F9D466"
      />
    </g>
    <path
      d="M113.505 35.5495C104.273 40.8535 98.5801 50.6887 98.5801 61.3363V72.1506C103.712 67.576 112.547 64.2897 122.919 63.4109C125.018 61.3175 127.943 57.1126 128.479 49.6393C129.016 57.1126 131.941 61.3175 134.039 63.4109C144.412 64.2899 153.246 67.576 158.378 72.1506V61.5163C158.378 50.7725 152.583 40.864 143.22 35.5966L142.899 35.4166C133.763 30.277 122.595 30.3275 113.505 35.5495Z"
      fill="#733127"
    />
  </Box>
)
export default AdultPrimaryCareDoctor
